module.exports = "<p>Connexion à Stratbox...</p>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/connect/connect.component.html
// module id = ../../../../../src/app/connect/connect.component.html
// module chunks = main